import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import Template from './template';
import MobileMenu from 'infosite/mobile-menu';

import {
  BrowserRouter as Router,
  Route,
  Link
} from 'react-router-dom';

export default class PageContentModule extends React.Component{
    constructor(props){
        super(props);
    }

    componentDidMount() {
      let $this = $(ReactDOM.findDOMNode(this));
      const isMobile = (window.medscape.isMobile ? window.medscape.isMobile : false);
      if(isMobile){
          MobileMenu.init(this.props.navigation,this.route);
      }

    }
    getTemplate(route){
      //console.log("Route:",route);
      this.route = route;
      const routePath = route.location.pathname;
      let page = this.props.pages.find((page)=>{
          return page.route == routePath;
      });
      page = page || this.props.pages[0];
      const TemplateProps = {
        page: page,
        navigation: this.props.navigation,
        route: route,
        isi: this.props.isi
      }
      return ( <Template {...TemplateProps} />);
    }
    render() {
        const basename = window.medscape.config.appServer ? window.medscape.config.appServer.path+'/' : '';
        //console.log("Route Basename: ",basename);
        console.log("Route Render");
        const RouteProps = {
          path: '/',
          component: this.getTemplate.bind(this)
        }
        return (
          <Router basename={basename}>
            <div id="page-content-module">
              <Route {...RouteProps}/>
            </div>
          </Router>
        )
    }
}

PageContentModule.propTypes={
    "pages": React.PropTypes.array.isRequired,
    "navigation": React.PropTypes.object.isRequired,
    "isi": React.PropTypes.object
}
PageContentModule.defaultProps={
  "isi": null
}



// WEBPACK FOOTER //
// ./src/app/page-content/app.jsx